import React, { useCallback } from "react";

const DragDropContext = React.createContext();

const CURSOR_STATES = {
  DISABLED: "no-drop",
  DRAGGING: "grabbing",
  DEFAULT: "grab",
};

export function useDragDropContext() {
  const ctx = React.useContext(DragDropContext);
  const [state, dispatch] = Array.isArray(ctx)
    ? ctx
    : [{ isDragging: false, disabled: false }, () => {}];

  const getCursor = useCallback(() => {
    if (state.disabled) return CURSOR_STATES.DISABLED;
    return state.isDragging ? CURSOR_STATES.DRAGGING : CURSOR_STATES.DEFAULT;
  }, [state.disabled, state.isDragging]);

  return [{ ...state, getCursor }, dispatch];
}

export function DragDropContextProvider({
  initState = { isDragging: false },
  children = null,
}) {
  const [store, dispatch] = React.useReducer((state, { type, value }) => {
    switch (type) {
      case "set-dragging":
        return { ...state, isDragging: value };
      case "set-disabled":
        return { ...state, disabled: value };
      default:
        return initState;
    }
  }, initState);

  return (
    <DragDropContext.Provider value={[store, dispatch]}>
      {children}
    </DragDropContext.Provider>
  );
}

export function WithDragDropContext(WrappedComponent) {
  return (props) => {
    return (
      <DragDropContextProvider>
        <WrappedComponent {...props} />
      </DragDropContextProvider>
    );
  };
}

export default WithDragDropContext;
